export default [
  /**
   * 欢迎页
   */
  {
    path: '/tumour/welcome',
    component: () => import('../page/tumour/welcome')
  },
  /**
   * 选择就诊人
   */
  {
    path: '/tumour/select/commpat',
    component: () => import('../page/tumour/select/commpat')
  },

  /**
   * 主页
   * @query.id
   */
  {
    path: '/tumour/index',
    component: () => import('../page/tumour/index')
  },
  /**
   * 日程提醒
   * @query.id
   */
  {
    path: '/tumour/programme',
    component: () => import('../page/tumour/programme')
  },
  /**
   * 选择主管医生
   * @query.id
   */
  {
    path: '/tumour/select/doc',
    component: () => import('../page/tumour/select/doc')
  },
  /**
   * 报告解读
   * @query.id
   */
  {
    path: '/tumour/report',
    component: () => import('../page/tumour/report')
  },
  /**
   * 每日清单
   * @query.id
   */
  {
    path: '/tumour/feelist',
    component: () => import('../page/tumour/feelist')
  },
  /**
   * 住院预缴金
   * @query.id
   */
  {
    path: '/tumour/fee',
    component: () => import('../page/tumour/fee')
  },
  /**
   * 住院记录
   * @query.id
   */
  {
    path: '/tumour/history',
    component: () => import('../page/tumour/history')
  },
  /**
   * 走进中心
   */
  {
    path: '/tumour/detail',
    component: () => import('../page/tumour/detail')
  },
  /**
   * 健康宣教
   */
  {
    path: '/tumour/news',
    component: () => import('../page/tumour/news')
  },
]



// WEBPACK FOOTER //
// ./src/router/tumour.js